import { Component } from '@angular/core';
import {HttpClient } from '@angular/common/http'; 
import { AuthService } from '../../_services'; 

@Component({
  selector: 'TS',
  templateUrl: './transferStation.component.html',  
})

 export class TsComponent {
 public prjId:any
 public userId:any
  constructor(private HttpClient : HttpClient,private auth : AuthService) { 
  }  
  ngOnInit() 
  { 
     
  }

}
 


// WEBPACK FOOTER //
// ./src/app/maintenance/TS/transferStation.component.ts